var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-hero-video-cropped"},[_c('app-video-background',{staticClass:"c-hero-video-cropped__video",attrs:{"video-id":_vm.videoId,"teaser":_vm.teaser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }